import { useTranslation } from 'react-i18next';

export default function About() {
  const { t } = useTranslation('common');

  return (
    <section id="family" className="grid grid-cols-1 md:grid-cols-2 min-h-screen">
      <div className="relative bg-purple-50 dark:bg-purple-900/20 p-12 flex items-center justify-center">
        
        <div className="relative w-full h-full">
          <img 
            src="https://public.readdy.ai/ai/img_res/231b1d0f061ba67eab3edff4849a9586.jpg"
            alt="UmiGo Community"
            className="w-full h-full object-cover object-top rounded-3xl"
          />
          
          <div className="absolute bottom-8 left-8 right-8">
            <h2 className="text-6xl font-black text-white leading-tight" style={{ lineHeight: '1.1' }}>
              {t('about.imageTitle1')}<br />{t('about.imageTitle2')}<br />{t('about.imageTitle3')}
            </h2>
          </div>
        </div>
      </div>

      <div className="bg-white dark:bg-gray-900 p-12 flex items-center justify-center">
        <div className="max-w-lg">
          <h2 className="text-5xl font-black text-gray-900 dark:text-gray-100 mb-8 leading-tight">
            {t('about.title')}<br />{t('about.titleLine2')}
          </h2>
          
          <div className="space-y-6 text-lg text-gray-600 dark:text-gray-400 leading-relaxed">
            <p>
              {t('about.paragraph1')}
            </p>
            
            <p>
              {t('about.paragraph2')}
            </p>
            
            <p>
              {t('about.paragraph3')}
            </p>
          </div>

          <div className="mt-12 text-center">
            <button className="px-12 py-4 bg-gradient-to-r from-orange-500 to-pink-500 text-white rounded-full font-bold text-lg hover:shadow-2xl transition-all inline-flex items-center gap-2 whitespace-nowrap">
              {t('about.joinButton')}
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
